import { home_intro as initializeBlock } from '../../blocks/home_intro/index.js';

const runBlock = () => initializeBlock(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runBlock, { once: true });
} else {
  runBlock();
}
